export const getCategoryLink = (slug: string) => `/blog/category/${slug}`
